<template>
  <!-- 急救状况生命体征记录: -->
  <div class="situation-container container">
    <span class="basic-title">急救状况</span>
    <div class="record-info">
      <situation-edit v-if="!isShowPatient" ref="editRef"/>
      <situation-look v-else/>
    </div>
  </div>
</template>
<script>
import SituationEdit from "@/components/patientsSmart/situations/SituationEdit";
import SituationLook from "@/components/patientsSmart/situations/SituationLook";
import { mapState } from "vuex";

export default {
  name: "Situation",
  components: {
    SituationLook,
    SituationEdit,
  },
  data() {
    return {

    };
  },
  computed: {
    ...mapState({
      patient: "showOrEditPatientInfo"
    }),
    isShowPatient() {
      return this.patient?.pageInfo?.isShowPatient;
    }
  },

};
</script>
<style lang="scss" scoped>
.situation-container {
  //margin-top: 24px; // 与前一个分离
  //width: 1432px;
  //background: #FFFFFF;
  //border-radius: 10px;
  //padding: 24px 36px;
}

.record-info {
  padding-top: 12px; // 分区信息标题(已经缩了12px了)
}

::v-deep .life {
  display: flex;
  justify-content: space-between;

  > div {
    display: flex;
  }
}
</style>
